@if (thread$ | async; as thread) {
  <div class="group">
    <!-- TODO:OLEH should be returned later after customer`s finished an active audit || class="group-hover:bg-blue-90 group-hover:text-white sticky top-0 z-10" || -->
    <app-thread-header
      class="group-hover:bg-blue-90 group-hover:text-white"
      [focused]="true"
      [resourceTypeDisplayName]="resource.resourceTypeDisplayName"
      [resourceDisplayName]="resource.resourceDisplayName"
    >
      <ng-container *featureFlag="'@commenting-full-access'; else ifCurrentUserTemplate">
        <ng-container *ngTemplateOutlet="resolveBtnTemplate"></ng-container>
      </ng-container>

      <ng-template #ifCurrentUserTemplate>
        <ng-container
          *ngTemplateOutlet="shouldMenuBeDisplayed(thread.initiatorId) && resolveBtnTemplate"
        ></ng-container>
      </ng-template>
    </app-thread-header>

    <div class="divide-y divide-navy-30">
      <app-comment-view
        class="border-b-0"
        [date]="thread.createdAt"
        [userId]="thread.initiatorId"
        [fallbackUserName]="thread.initiatorName"
        [body]="thread.body"
        [displayMenu]="shouldMenuBeDisplayed(thread.initiatorId) || (isFullAccess$ | async)"
        [commentType]="'thread'"
        [commentId]="thread.id"
        (edit)="editThread(thread.id, $event)"
        (delete)="deleteThread()"
      ></app-comment-view>
    </div>

    <div class="divide-y divide-navy-30">
      @if (hiddenCommentsLength || collapsedComments.length; as repliesCount) {
        <app-item-divider
          hidden
          [title]="
            buildTranslationKey(hiddenCommentsLength ? 'showMoreBtn' : 'repliesCounterTxt')
              | translate: { repliesCount: repliesCount }
          "
          [isHoverable]="!!hiddenCommentsLength"
          (titleClicked)="showAllComments()"
        ></app-item-divider>
      }

      @for (comment of collapsedComments; track trackCommentByIds($index, comment)) {
        <app-comment-view
          [date]="comment.createdAt"
          [userId]="comment.commenterId"
          [fallbackUserName]="comment.commenterName"
          [body]="comment.body"
          [displayMenu]="shouldMenuBeDisplayedForComment(comment.commenterId, comment) || (isFullAccess$ | async)"
          [commentType]="'comment'"
          [commentId]="comment.id"
          (edit)="editComment(comment.id, $event)"
          (delete)="deleteComment(comment.id)"
        ></app-comment-view>
      }
    </div>

    <!-- TODO:OLEH should be returned later after customer`s finished an active audit || class="sticky z-10 bottom-0 bg-white" || -->
    <app-reply class="bg-white" [threadId]="thread.id"></app-reply>
  </div>
}

<ng-template #resolveBtnTemplate>
  <app-resolve-button
    data-test-id="resolve-thread-btn"
    class="cursor-pointer group-hover:opacity-100 opacity-0"
    [tooltipTranslationText]="buildTranslationKey('resolveBtnTooltip')"
    [class.opacity-100]="true"
    [isResolveSingleThreadButton]="true"
    (click)="$event.stopPropagation(); resolveThread()"
  ></app-resolve-button>
</ng-template>
